var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var SearchkitComponent_1 = require("./SearchkitComponent");

var LoadingComponent = function (_super) {
  __extends(LoadingComponent, _super);

  function LoadingComponent() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  LoadingComponent.prototype.render = function () {
    if (this.isLoading()) {
      return this.props.children;
    }

    return React.createElement("div", null);
  };

  return LoadingComponent;
}(SearchkitComponent_1.SearchkitComponent);

exports.LoadingComponent = LoadingComponent;